module.exports = __webpack_public_path__ + "static/media/ChessEvent1.efc7d30b.jpeg";